module.exports = __webpack_public_path__ + "img/abandono.df99c439.png";